import VennChart from './VennChart'

export default VennChart;